import type { SiteTemplateKey } from "@/lib/siteTemplates";
import { getTemplateStyles } from "@/lib/siteTemplateStyles";

type StatItem = {
  label?: string;
  value?: string;
  suffix?: string;
};

export function StatsBandBlock({
  content,
  template = "classic",
}: {
  content: Record<string, unknown>;
  template?: SiteTemplateKey;
}) {
  const heading = String(content.heading ?? "");
  const intro = String(content.intro ?? "");
  const stats = (Array.isArray(content.stats) ? content.stats : []) as StatItem[];
  const styles = getTemplateStyles(template);

  if (stats.length === 0 && !heading && !intro) return null;

  return (
    <section className="w-full bg-[var(--color-surface-muted)] py-[calc(var(--space-unit)*3)]">
      <div className={styles.textGroup.section}>
        {(heading || intro) && (
          <div className="mb-[calc(var(--space-unit)*1.5)] max-w-3xl">
            {heading && (
              <h2
                className="font-bold text-[var(--color-text)]"
                style={{ fontFamily: "var(--font-heading)", fontSize: "var(--text-h2)", lineHeight: "var(--line-heading)" }}
              >
                {heading}
              </h2>
            )}
            {intro && <p className="mt-2 text-[var(--color-text)]/70">{intro}</p>}
          </div>
        )}
        <div className="grid grid-cols-1 gap-[calc(var(--space-unit)*1.5)] sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, index) => (
            <div key={index} className={styles.textGroup.card}>
              <p
                className="text-[rgb(var(--color-primary))]"
                style={{ fontFamily: "var(--font-heading)", fontSize: "var(--text-h1)", lineHeight: "var(--line-display)" }}
              >
                <span>{stat.value ?? "0"}</span>
                {stat.suffix ? (
                  <span className="text-[var(--color-text)]/70">{stat.suffix}</span>
                ) : null}
              </p>
              {stat.label && <p className="mt-1 text-sm text-[var(--color-text)]/70">{stat.label}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
